import React from 'react';
import SoftwareFlowDiagram from './SoftwareFlowDiagram';

const Traceability = () => {
    return (
        <section id="traceability" className="py-8 border-b border-slate-100 overflow-hidden bg-slate-50/30">
            <div className="section-padding">
                <div className="grid lg:grid-cols-2 gap-12 items-center">
                    <div className="order-2 lg:order-1 flex justify-center">
                        <div className="relative w-full max-w-[500px] scale-95 sm:scale-100 lg:scale-110">
                            <SoftwareFlowDiagram />
                        </div>
                    </div>

                    <div className="order-1 lg:order-2">
                        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-50 border border-indigo-100 text-indigo-700 text-[10px] font-bold uppercase tracking-wider mb-6">
                            Real-Time Data Engine
                        </div>

                        <h2 className="heading-lg mb-6">
                            Absolute <span className="gradient-text font-black">Precision</span> in Every Movement
                        </h2>

                        <p className="text-p text-slate-500 mb-10 pb-6 border-b border-slate-100">
                            Switch between high-level batch overviews and deep dependency graphs in seconds with our proprietary tracing algorithm.
                        </p>

                        <div className="space-y-8 mb-12">
                            {[
                                {
                                    title: 'Graph Overview',
                                    desc: 'Visualize complex manufacturing processes with a full 360-degree dependency tree.',
                                    icon: (
                                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-3" />
                                        </svg>
                                    )
                                },
                                {
                                    title: 'Simple Batch Traversal',
                                    desc: 'Focus on individual product journeys from raw materials to customer dispatch.',
                                    icon: (
                                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                        </svg>
                                    )
                                },
                                {
                                    title: 'Dispatch Tracking',
                                    desc: 'Monitor output streams including warehouse stock, secondary products, and customer shipments.',
                                    icon: (
                                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
                                        </svg>
                                    )
                                }
                            ].map((item, i) => (
                                <div key={i} className="flex gap-5 group">
                                    <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-indigo-600 to-sky-500 rounded-2xl flex items-center justify-center text-white shadow-lg shadow-indigo-200 transition-all duration-300">
                                        {item.icon}
                                    </div>
                                    <div>
                                        <h4 className="font-bold mb-1 tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-sky-500 transition-all uppercase text-[11px] tracking-widest">{item.title}</h4>
                                        <p className="text-slate-500 text-sm leading-relaxed max-w-md">{item.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Traceability;
